<form class="example-form mb-0">
  <mat-form-field appearance="outline" class="w-100 mb-0 search-field">
    <mat-label>Cerca prodotto o servizio...</mat-label>
    <input
      type="text"
      placeholder="Digita qui"
      aria-label="Prodotto o servizio"
      matInput
      [formControl]="productControl"
      [matAutocomplete]="auto"
    />
    <mat-icon matSuffix>search</mat-icon>
    <mat-autocomplete #auto="matAutocomplete">
      @for (option of filteredOptions | async; track option) {
      <mat-option 
        [value]="option"
        (onSelectionChange)="onOptionSelected($event, option)">
        {{option}}
      </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</form>
